var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncentiveInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7729 23.3241C25.7729 23.3241 20.9685 5.81695 31.7105 1.16463C38.325 10.4676 25.7729 23.3241 25.7729 23.3241Z",
    fill: "#486581"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1193 15.7058C46.1193 15.7058 28.6121 10.9014 23.9598 21.6434C33.2628 28.2579 46.1193 15.7058 46.1193 15.7058Z",
    fill: "#486581"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0103 7.35752C40.0103 7.35752 22.4465 11.9504 23.7885 23.5794C35.1523 24.6562 40.0103 7.35752 40.0103 7.35752Z",
    fill: "#486581"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15687 35.3949L5.73653 35.9746C6.51757 36.7556 7.7839 36.7556 8.56495 35.9746C9.346 35.1935 9.346 33.9272 8.56495 33.1461L7.18263 31.7638L9.20839 28.1327L11.3934 30.3177C12.1744 31.0988 13.4408 31.0988 14.2218 30.3177C15.0029 29.5367 15.0029 28.2703 14.2218 27.4893L11.3934 24.6609C11.3404 24.6079 11.2852 24.5585 11.228 24.5127L13.2599 20.8705L17.0502 24.6609C17.8313 25.4419 19.0976 25.4419 19.8787 24.6609C20.6597 23.8798 20.6597 22.6135 19.8787 21.8324L15.636 17.5898C15.5193 17.473 15.3916 17.3737 15.2564 17.2919L15.7455 16.4152C16.8218 14.486 19.2583 13.7945 21.1875 14.8708C21.51 15.0508 21.806 15.2745 22.0671 15.5356L31.8325 25.301C33.3946 26.8631 33.3946 29.3957 31.8325 30.9578C31.5714 31.2189 31.2753 31.4426 30.9529 31.6226L6.93748 45.0206C5.62008 45.7555 3.97487 45.5266 2.90816 44.4599C1.84145 43.3932 1.61253 41.748 2.3475 40.4306L5.15687 35.3949Z",
    fill: "#243B53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentiveInactive);
export default __webpack_public_path__ + "static/media/incentive-inactive.20bbb5418857c3a2a06f59c694e36504.svg";
export { ForwardRef as ReactComponent };